// Console Banner para Alihuen Joyas
// Desarrollado por SoulWalle - Pherhosting

const showConsoleBanner = () => {
  const banner = `
╔══════════════════════════════════════════════════════════════════════════════╗
║      __________             .__                    __                        ║
║      \\______   \\ ___________|  |__   ____  _______/  |_                      ║
║      |     ___// __ \\_  __ \\  |  \\ /  _ \\/  ___/\\   __\\                      ║
║      |    |   \\  ___/|  | \\/   Y  (  <_> )___ \\  |  |                        ║
║      |____|    \\___  >__|  |___|  /\\____/____  > |__|                        ║
║                    \\/           \\/           \\/                              ║
║                                                                              ║
║                                                                              ║
║                                                                              ║
║                           .__                .__  .__                        ║
║          __________  __ __|  |__  _  _______ |  | |  |   ____                ║
║        /  ___/  _ \\|  |  \\  |\\ \\/ \\/ /\\__  \\ |  | |  | _/ __ \\               ║
║        \\___ (  <_> )  |  /  |_\\     /  / __ \\|  |_|  |_\\  ___/               ║
║        /____  >____/|____/|____/\\/\\_/  (____  /____/____/\\___>               ║
║             \\/                              \\/                               ║
║                   🚀 DESARROLLADOR FULL STACK 🚀                            ║
║                                                                              ║
║  👤 Nombre: Sebastias Salamanca                                             ║                                           
║  📧 Email: sebastiassalamanca@gmail.com                                     ║
║  🌍 pagina :                                                                ║                            
║  🐙 GitHub: https://github.com/Seb4stias                                    ║
║                                                                              ║
║  ⚡ Stack: React • Node.js • MongoDB • Express                              ║
║  🎨 Diseño: Responsive • Modern UI • UX/UI                                  ║
║  🔒 Seguridad: JWT • bcrypt • Rate Limiting                                 ║
║                                                                             ║               
║                                                                             ║
║  © 2026 - Todos los derechos reservados                                     ║
╚══════════════════════════════════════════════════════════════════════════════╝
  `;

  // Mostrar el banner
  
  console.log(banner);
  
  // Información del sistema
  console.log('%c🛡️ SISTEMA PROTEGIDO - HOSAN', 'color: #d4af37; font-size: 16px; font-weight: bold;');
  console.log('%c⚡ Desarrollado por Sebastias Salamanca - Pherhosting', 'color: #d4af37; font-size: 12px;');
  console.log('%c🔐 Sistema de administración Sebastian implementado', 'color: #00ff00; font-size: 12px;');
  console.log('%c📊 Analytics y tracking de tráfico activo', 'color: #00ff00; font-size: 12px;');
  console.log('%c🚀 Desplegado en Vercel con MongoDB Atlas', 'color: #00ff00; font-size: 12px;');
  console.log('%c⚠️  Acceso no autorizado será registrado y reportado', 'color: #ff4444; font-size: 12px; font-weight: bold;');
  console.log('%c' + '='.repeat(80), 'color: #d4af37;');
  
  // Información adicional para desarrolladores
  console.log('%c🏭 HOSAN - Sistema de Gestión v1.0', 'color: #d4af37; font-size: 14px; font-weight: bold;');
  console.log('%c🎨 Frontend: React.js + CSS Variables', 'color: #61dafb; font-size: 11px;');
  console.log('%c⚙️  Backend: Node.js + Express + MongoDB', 'color: #68a063; font-size: 11px;');
  console.log('%c📱 Responsive Design + Mobile First', 'color: #ff6b6b; font-size: 11px;');
  console.log('%c🔒 JWT Authentication + Bcrypt', 'color: #feca57; font-size: 11px;');
  console.log('%c📈 Google Analytics + Custom Tracking', 'color: #48dbfb; font-size: 11px;');
  console.log('%c' + '='.repeat(80), 'color: #d4af37;');
};

export default showConsoleBanner;